export const eachPos = (c, fn) => {

    for (let y = 0; y < c.height; y++) {
        for (let x = 0; x < c.width; x++) {
            const pos = {x,y};
            fn(pos);
        }
    }
};
